import React, { useEffect, useRef, useState} from 'react';
import { Formik, Form, Field } from 'formik';
import { useNavigate, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import { useModal } from '../../contexts/ModalContext';
import {enrolementProfileApi, validateFormConfirm} from "../../services/UserService";
import form_styles from "../../components/Form/Form.module.css";
import styles from "./ConfirmationPage.module.css";
import FieldCustom from "../../components/Field/FieldCustom";
import {useUser} from "../../contexts/UserContext";
import FieldPassword from "../../components/Field/FieldPassword";
import FieldCheckbox from "../../components/Field/FieldCheckbox";
import {getEntrepriseWithToken} from "../../services/EntrepriseService";
import stylesField from "../../components/Field/Field.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import Routing from "../../services/routing";

function EnrolementProfilPage() {
    const { user } = useUser();
    const { showModal, hideModal } = useModal();
    const [entreprise, setEntreprise] = useState();
    const { token } = useParams();
    const { uid } = useParams();
    const [inputs, setInputs] = useState([]);
    const [initialValues, setInitialValues] = useState();
    const navigate = useNavigate();
    const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const [captchaValue, setCaptchaValue] = useState('');
    const recaptchaRef = useRef(null);

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleCaptchaLoaded = () => {
        setCaptchaLoaded(true);
    };

    const renderCaptcha = () => {
        const captchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
        if (!captchaKey) {
            console.error("Captcha key is missing");
            return null;
        }

        return (
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={captchaKey}
                size="invisible"
                onChange={onCaptchaChange}
                asyncScriptOnLoad={handleCaptchaLoaded}
            />
        );
    };

    useEffect(() => {
        if (captchaLoaded && recaptchaRef.current) {
            recaptchaRef.current.execute();
        }
    }, [captchaLoaded]);


    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 3000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 3000});
    };

    useEffect(() => {
        if (user && !user.roles.includes("ROLE_ADMIN") && !user.roles.includes("ROLE_REFERENT")) {
            return navigate(Routing.routes.home);
        }
    }, [user]);

    useEffect(() => {
        if (!token || !uid) return;

        // if(!validateEmail(uid)) {
        //     handleError("Email invalide");
        //     return;
        // }

        const fetchEntreprise = async () => {
            try {
                const response = await getEntrepriseWithToken(token, uid);
                if (response.success){
                    setEntreprise(response.entreprise);
                } else {
                    // handleError(response.msg);
                    console.error(response.msg);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données de l\'entreprise :', error);
            }
        }

        fetchEntreprise();
    }, [token, uid]);

    useEffect(() => {
        if (!entreprise) return;

        const newInputs = [
            { type: 'text', name: 'nom', label: 'Nom', value: ''},
            { type: 'text', name: 'prenom', label: 'Prénom', value: '' },
            { type: 'date', name: 'birth_date', label: 'Date de naissance', value: '' },
            { type: 'email', name: 'email', label: 'Email', value: '' },
            { type: 'number', name: 'mobile', label: 'Mobile', value: '' },
            { type: 'password', name: 'password', label: 'Mot de passe', value: ""},
            { type: 'password', name: 'password_confirm', label: 'Confirmation du mot de passe', value: ""},
            { type: 'checkbox', name: 'cgu', label: 'Accepter les CGU', value: false},
            { type: 'hidden', name: 'token', label: '', value: token },
            { type: 'hidden', name: 'uid', label: '', value: uid },
            { type: 'hidden', name: 'captchaToken', label: '', value: "" },
        ];
        setInputs(newInputs);

        const newInitialValues = newInputs.reduce((acc, input) => ({
            ...acc,
            [input.name]: input.value,
        }), {});

        setInitialValues(newInitialValues);
    }, [entreprise]);

    const handleSubmit = async (values, { setSubmitting }) => {
        if (!captchaValue) {
            handleError('Veuillez vérifier que vous n\'êtes pas un robot');
            setSubmitting(false);
            return;
        }

        values.captchaToken = captchaValue;

        try {
            const response = await enrolementProfileApi(values);
            if (response.success){
                handleSuccess(response.msg);

                setTimeout(() => {
                    // Si referent ou admin redirigé vers la page salaries
                    if (user?.roles?.includes("ROLE_ADMIN") || user?.roles?.includes("ROLE_REFERENT")) {
                        navigate(Routing.routes.salaries);
                        return;
                    }

                    navigate(Routing.routes.login, { state: { email: response.email } });
                }, 1500);
            } else {
                handleError(response.msg);
            }
        } catch (error) {
            handleError( "Une erreur est survenue : "+ error.message);
            console.error(error);
        }
        setSubmitting(false);
    };


    return (
        <div className="content">
            <TitleMain text="VOTRE PROFIL"/>
            {initialValues  ?
                <Formik
                    initialValues={initialValues}
                    validate={validateFormConfirm}
                    onSubmit={handleSubmit}
                >
                    {formik => (
                        <Form className={form_styles.form}>
                            <div className={stylesField.select}>
                                <span>Civilité</span>
                                <Field as="select" name="civilite">
                                    <option>
                                        -- Sélectionnez une civilité --
                                    </option>
                                    <option value={"4"}>
                                        Monsieur
                                    </option>
                                    <option value={"3"}>
                                        Madame
                                    </option>
                                </Field>
                            </div>
                            {inputs.map(({type, name, label}, index) => {
                                let FieldComponent = FieldCustom;
                                if (type === 'password') {
                                    FieldComponent = FieldPassword;
                                } else if (type === 'checkbox') {
                                    FieldComponent = FieldCheckbox;
                                }
                                return (
                                    <div key={index}>
                                        <FieldComponent name={name} label={label} type={type}/>
                                    </div>
                                );
                            })}

                            {renderCaptcha()}

                            <button type="submit" className={`${form_styles.btnSubmit} btn`}>ENREGISTRER</button>
                        </Form>
                    )}
                </Formik>

                :
                <div className={styles.getUtilisateurFailure}>
                    <h4 className={styles.titleParagraph}>👋 Bienvenue ! </h4>
                    <p>
                        Pour commencer, activez votre compte en cliquant sur le lien que nous vous avons envoyé par
                        e-mail.
                    </p>

                    <h4 className={styles.titleParagraph}>Rien dans votre boîte de réception ?</h4>
                    <p>
                        Jetez un œil dans vos spams ! Le lien d'activation est valable jusqu'à
                        minuit.
                    </p>

                </div>

            }
        </div>
    );
}

export default EnrolementProfilPage;
